import { useQuery } from '@tanstack/react-query';
import { Offering, getOffering } from '../clients/offering-client';

export const useOffering = (offeringId: string) => {
  return useQuery<Offering>([`offering-${offeringId}`], () =>
    getOffering(offeringId)
  );
};
